import {
  MOVE_ITEM_REQUEST,
  MOVE_ITEM_SUCCESS,
  MOVE_ITEM_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const moveItem = (state = initialState, action) => {
  const types = {
    [MOVE_ITEM_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [MOVE_ITEM_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [MOVE_ITEM_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default moveItem;
